// types
import { type ModuleType as Quoter } from "./_definitions"
import { type State } from "../../types"

export const quoterSelector = (state: State): Quoter => state.quoter
